import { useMessageContext } from "providers/MessageProvider";
import React from "react";
import { useTranslation } from "react-i18next";
import { Container, StyledButton, StyledHeading } from "./styles";

const Solution: React.FC = () => {
  const { t } = useTranslation();
  const { isFormVisible, isFormSuccessVisible, onShowForm } =
    useMessageContext();

  return (
    <Container isVisible={!isFormSuccessVisible} isFormVisible={isFormVisible}>
      <div id="heading">
        <StyledHeading variant="h5" elementType="h3" align="center">
          {t("10206") /* A solução para a sua cidade */}
        </StyledHeading>
        <StyledHeading variant="h6" elementType="h4" align="center">
          {t("10171") /* Deixe-nos a sua mensagem para mais informações. */}
        </StyledHeading>
      </div>
      <StyledButton
        color="secondary"
        className="mt-20"
        onClick={onShowForm}
        isFormVisible={isFormVisible}
      >
        {t("6357") /* Enviar mensagem */}
      </StyledButton>
    </Container>
  );
};

export default Solution;
